













import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
@Component({})
export default class Pagination extends Vue {
  @Prop(Number) total!: number;
  @Prop(Number) pageSize!: number;
  @Prop(Number) currentPage!: number;
  @Prop(Function) sizeCb!: Function;
  @Prop(Function) pageCb!: Function;

  get pageSizes() {
    let arr = [],
      baseSize = 20;
    for (let i = 0, len = Math.ceil(this.total / baseSize); i < len; i++) {
      arr.push(baseSize * (i + 1));
      if (baseSize * (i + 1) >= 200) {
        break;
      }
    }
    return arr;
  }
}
